import { useState } from 'react';

export function useUIStateManager() {
  const [layersPanelVisible, setLayersPanelVisible] = useState<boolean>(false);
  const [settingsPanelVisible, setSettingsPanelVisible] = useState<boolean>(false);
  const [selectingDataSource, setSelectingDataSource] = useState<boolean>(false);
  const [selectingMap, setSelectingMap] = useState<boolean>(false);

  return {
    layersPanelVisible,
    setLayersPanelVisible,
    settingsPanelVisible,
    setSettingsPanelVisible,
    selectingDataSource,
    setSelectingDataSource,
    selectingMap,
    setSelectingMap,
  };
}
